import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSearchMedium(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 1.7a7.8 7.8 0 0 1 6.206 12.522l5.036 5.036a1.05 1.05 0 1 1-1.484 1.484l-5.036-5.036A7.8 7.8 0 1 1 9.5 1.7m0 2.1a5.7 5.7 0 1 0 0 11.4 5.7 5.7 0 0 0 0-11.4",
    clipRule: "evenodd"
  }));
}
var IcSearchMedium = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSearchMedium));

export { IcSearchMedium as I };
